import { gql } from '@apollo/client';

export const RemoveCourseMutation = gql`
    mutation RemoveCourse($id: ID!) {
        removeOLCourse(id: $id)
    }
`;
